import { ClickAwayListener } from "@material-ui/core";
 import { useDispatch, useSelector } from "react-redux";
import { GetMonitoringOrdersListData } from "../../../../../hooks/GetMonitoringOrdersListData";
import { SetDriverPopUp, SetSelectedMonitoringDriver, SetSelectedMonitoringOrder, SetOrderPinPopUp, Table_SelecteMultiOrders, Table_ClearSelectedOrders, Table_DeSelectOrder } from "../../../../../Redux/actions/actionNames";
import { GetColorByStatus } from "../../../../../utils/get-colors-by-status";
import { DropOffPin_Selection } from "../../../../shared/map-dropoff-pin_selection";
import { PickupPin_Selection } from "../../../../shared/map-pickup-pin_selction";
import { OrderPinPopUp } from "../../../../shared/order-pin-popup";
import styles from './style.module.css';
import useSupercluster from "use-supercluster";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ClusterPin } from "../../../../shared/map-Cluster-pin";
import { Circle, DrawingManager, Marker, Polygon, Rectangle } from "@react-google-maps/api";
import { coordinateFuncsToCoordinates } from "../../../../shared/map-container/utils";
import * as R from "ramda";
import { SelectedTableOrdersMapsMaper } from "../../../../../helper/worker/SelectedTableOrdersMapsMaper";
import styled from "styled-components";
 import { EditControl } from "react-leaflet-draw";
import { FeatureGroup } from "react-leaflet";
import { OrderPinPopUp_selection } from "../../../../shared/order-pin-popup_selection";



const ButtonsContainer = styled("div")`
  position: absolute;
  left: 50%;
  bottom: 50px;

  transform: translateX(-50%);
`;


export const DefaultPolygonOptions = {
    borderColor: "blue",
    backgroundColor: "blue",
    borderWidth: 1,
};

export const OrdersList = (props) => {

    const TableList = useSelector((state) => state.Table.list?.orders)
    const mapRef = useSelector((state) => state.Map.mapRef)
     const DrawingRef = useSelector((state) => state.Map.drawingRef)

    const bounds = useSelector((state) => state.Map.bounds)
    const zoom = useSelector((state) => state.Map.zoom)
    const drawingRef = useRef(null);
    const [polygons, setPolygons] = useState([]);
    const [rectangle, setRectangle] = useState([]);
    const [circle, setCircle] = useState([]);
    const dispatch = useDispatch();
    const [orderedTableList, setOrderedTableList] = useState([]);
    const selectedOrders = useSelector((state) => state.Table.selectedOrders)
     const showPickup = useSelector((state) => state.Monitoring.orders.showPickup)
    const showDelivery = useSelector((state) => state.Monitoring.orders.showDelivery)

    const [drawing, setDrawing] = useState(false);
    const isCtrlOrMetaPressed = useRef(false);

    // در useEffect یکبار این رو اضافه کن
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey || e.metaKey) {
                isCtrlOrMetaPressed.current = true;
            }
        };

        const handleKeyUp = () => {
            isCtrlOrMetaPressed.current = false;
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, []);


    const points = useMemo(() => {
        if(!TableList){
            return []
        }
        const crimes = TableList;
        let arr = []

    try {
            crimes.forEach(crime => {
                if (crime.pickup && showPickup) {
                    arr.push({
                        type: "Feature",
                        properties: {
                            cluster: false,
                            ...crime,
                            category: "pickup",
                            selected: !!selectedOrders[crime.id]
      
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [
                                parseFloat(crime.pickup.coordinates[0]),
                                parseFloat(crime.pickup.coordinates[1])
                            ]
                        }
                    })
                }
     if (crime.delivery && showDelivery) {
                    arr.push({
                        type: "Feature",
                        properties: {
                            cluster: false,
                            ...crime,
                            category: "delivery",
                            selected: !!selectedOrders[crime.id],
                        },
    
                        geometry: {
                            type: "Point",
                            coordinates: [
                                parseFloat(crime.delivery.coordinates[0]),
                                parseFloat(crime.delivery.coordinates[1])
                            ]
                        }
                    })
                }
                
        //         if (crime.dropoffs) {
    
        //             crime.dropoffs.forEach((item)=>{
        //   arr.push({
        //                 type: "Feature",
        //                 properties: {
        //                     cluster: false,
        //                     ...crime,
        //                     category: "delivery",
     
        //                 },
        //                 geometry: {
        //                     type: "Point",
        //               coordinates: [
        //                         parseFloat(item.coordinates[0]),
        //                         parseFloat(item.coordinates[1])
        //                     ]
        //                 }
        //             })
        //             })
              
        //         }
            });
    } catch (error) {
        
    }

        return arr


    }, [TableList, selectedOrders , showDelivery , showPickup]);

      const superclusterBounds  = bounds
          ? (bounds.southWest ? [
              bounds.southWest.lng,
              bounds.southWest.lat,
              bounds.northEast.lng,
              bounds.northEast.lat,
          ] : [
        bounds.getSouthWest().lng(),
        bounds.getSouthWest().lat(),
        bounds.getNorthEast().lng(),
        bounds.getNorthEast().lat(),
          ])
    : [0, 0, 0, 0];

    const { clusters ,supercluster} = useSupercluster({
        points,
        zoom ,
        bounds : superclusterBounds,
        options: { radius: 75, maxZoom: 18, minZoom: 2 }
    });




    const Newclusters = useMemo(() => {


        let jj = clusters.map((item) => {



            if (!item.properties.cluster) {
                return item
            }

            let cpoint = supercluster?.getLeaves(item.id, 5000)

            const anySelected = cpoint.some(itemx => itemx.properties.selected);
            const allSelected = cpoint.every(itemx => itemx.properties.selected);

            console.log("Newclusters clusters :", item, cpoint, anySelected, allSelected)

            return {
                ...item,
                properties: {
                    ...item.properties,
                    cpoint: cpoint,
                    selected: allSelected || anySelected,
                    allSelected: allSelected

                },
            }
        })

        return jj
        // let cpoint = supercluster?.getLeaves(id, 5000)
        // return cpoint

    }, [selectedOrders, clusters]);

    const GM_resetDrawingToolsMode = () => {
        drawingRef.current?.state.drawingManager?.setDrawingMode(null);
      //  dispatch({type : "drawingRefMode" , state:null})

    };

    const GM_checkSelectedOrdersInShapes = useCallback((coordinates) => {
         let selected = [];

          console.log("GM_checkSelectedOrdersInShapes", Newclusters, coordinates);

        Newclusters.forEach((item) => {

            if (pointIsInPolygon({ lat: item.geometry.coordinates[1], lng: item.geometry.coordinates[0] }, coordinates)) {
                if (item.properties?.cluster) {
                    let orders = supercluster.getLeaves(item.id, 5000)
                    orders.forEach((itemx) => {
                        selected.push(itemx.properties)
                    })
                } else {
                    selected.push(item.properties)
                }
            }

         })

        dispatch(Table_SelecteMultiOrders(selected))


    }, [Newclusters, supercluster]);

    const clusterSave = useCallback((clusterId) => {
        let selected = [];





        let orders = supercluster.getLeaves(clusterId, 5000)
        orders.forEach((itemx) => {
            selected.push(itemx.properties)
        })



        dispatch(Table_SelecteMultiOrders(selected))


    }, [Newclusters, supercluster]);

        const clusteDeselct = useCallback((clusterId) => {
 
        let orders = supercluster.getLeaves(clusterId, 5000)
        orders.forEach((itemx) => {
             dispatch(Table_DeSelectOrder(itemx.properties.id))
        })
 
    }, [Newclusters, supercluster]);



    const GM_checkSelectedOrdersInRectangle = useCallback((rectangleCoordinates) => {
        let selected = [];
        console.log("GM_checkSelected", Newclusters, rectangleCoordinates);

        Newclusters.forEach((item) => {
            const point = {
                lat: item.geometry.coordinates[1],
                lng: item.geometry.coordinates[0]
            };

        if (pointIsInRectangle(point, rectangleCoordinates)) {


            if (item.properties?.cluster) {
                let orders = supercluster.getLeaves(item.id, 5000);
                orders.forEach((itemx) => {
                    selected.push(itemx.properties);
                });
            } else {
                selected.push(item.properties);
            }
        }

    });

        console.log("GM_checkSelectedOrdersInShapes ", rectangleCoordinates);

        dispatch(Table_SelecteMultiOrders(selected));
    }, [Newclusters, supercluster]);


   const handleClick = useCallback(( ) => {

      try {
   
          if (!drawing) {
               drawingRef.current.leafletElement._toolbars.draw._modes.rectangle.handler.enable();
          } else {
               drawingRef.current.leafletElement._toolbars.draw._modes.rectangle.handler.completeShape();
               drawingRef.current.leafletElement._toolbars.draw._modes.rectangle.handler.disable();
          }
 
          setDrawing(!drawing)

      } catch (error) {
        
      }
    }, [drawing , drawingRef]);
   const onShapeDrawn = useCallback((e) => {

             const wasCtrlPressed = isCtrlOrMetaPressed.current;
                    console.log("Ctrl/Meta pressed?", wasCtrlPressed);


       const layer = e.layer; // دسترسی به لایه جدید



      // dispatch({ type: "drawingRefMode", state: null })
      // drawingRef.current.leafletElement._toolbars.draw._modes.rectangle.handler.disable();

        setDrawing(false)

 
       if (e.layerType == "rectangle") {


           const layer = e.layer; // دسترسی به لایه جدید
           const bounds = layer.getBounds();

           const southWest = bounds.getSouthWest();
           const northEast = bounds.getNorthEast();

           if (wasCtrlPressed) {
               GM_checkSelectedOrdersInRectangle({
                   southWest: { lat: bounds.getSouthWest().lat, lng: bounds.getSouthWest().lng },
                   northEast: { lat: bounds.getNorthEast().lat, lng: bounds.getNorthEast().lng },
               })
           } else {
               dispatch(Table_ClearSelectedOrders())
               GM_checkSelectedOrdersInRectangle({
                   southWest: { lat: bounds.getSouthWest().lat, lng: bounds.getSouthWest().lng },
                   northEast: { lat: bounds.getNorthEast().lat, lng: bounds.getNorthEast().lng },
               })
           }



       setTimeout(() => {
         drawingRef?.current?.leafletElement._toolbars.draw._modes.rectangle.handler.enable();
       }, 500);

       }

       if (e.layerType == "polygon") {

           const geometry = layer.toGeoJSON(); // تبدیل لایه به GeoJSON برای دسترسی به مختصات
 

         const latlngs = layer.getLatLngs();
        let coordinates = []; // آرایه برای ذخیره مختصات

            // اگر پالیگون چندگانه باشد
            if (Array.isArray(latlngs[0])) {
            latlngs.forEach((polygon) => {
                polygon.forEach((latlng) => {
                coordinates.push({ lat: latlng.lat, lng: latlng.lng });
                });
            });
            } else {
            // اگر یک پالیگون ساده باشد
            latlngs.forEach((latlng) => {
                coordinates.push({ lat: latlng.lat, lng: latlng.lng });
            });
            }

            
           if (wasCtrlPressed) {
                       GM_checkSelectedOrdersInShapes(coordinates)

           } else {
               dispatch(Table_ClearSelectedOrders())
                         GM_checkSelectedOrdersInShapes(coordinates)

           }



        setTimeout(() => {
            drawingRef?.current?.leafletElement._toolbars.draw._modes.polygon.handler.enable();
        }, 500);

       }

       try {




           const map = mapRef.current.leafletElement; // دسترسی به نقشه

           // حذف لایه از نقشه
           map.removeLayer(layer);
       } catch (error) {

       }

   }, [mapRef, Newclusters , drawingRef ,isCtrlOrMetaPressed ]);


  

 
   useEffect(() => {
    if(drawingRef && (!DrawingRef || !DrawingRef?.current)){
       dispatch({type : "set_drawingRef" , state:drawingRef})
    }
    
    }, [drawingRef, DrawingRef] )



  

     return <>
         {Newclusters.map((cluster, i) => {
            const [longitude, latitude] = cluster.geometry.coordinates;
            const { properties } = cluster;
            if ( properties.cluster) {
                const { point_count: pointCount, allSelected, selected } = properties;
              return (
                  <>
                      <ClusterPin
                {...props} 
                onClick={(event)=>{


                        if (event.metaKey || event.ctrlKey || event.originalEvent?.metaKey || event.originalEvent?.ctrlKey || event.domEvent?.metaKey || event.domEvent?.ctrlKey) {
                          if (selected) {
                            clusteDeselct(cluster.id)
                          } else {
                            clusterSave(cluster.id)
                    
                          }
                    
                        } else {
                    
                         // dispatch(Table_ClearSelectedOrders())

                        //      if (selected) {
                        //     clusteDeselct(cluster.id)
                        //   } else {
                        //   dispatch({ type: "selectedCluster", state: supercluster.getLeaves(cluster.id, 5000) })
                    
                        //   }
                                              dispatch({ type: "selectedCluster", state: supercluster.getLeaves(cluster.id, 5000) })


                    
                             }

                    //  if (event.metaKey || event.ctrlKey || event.originalEvent?.metaKey || event.originalEvent?.ctrlKey) {
                    //     clusterSave(cluster.id)

                    //   }else{
                        
                    //     dispatch({ type: "selectedCluster", state: supercluster.getLeaves(cluster.id, 5000) })

                    //   }
                }}
                          big={selected}
                          color={allSelected ? "rgba(16, 128, 255, 0.4)" : "rgba(233, 149, 20, 0.4)"}
                  key={`cluster-${cluster.id}`}
                  id={`cluster-${cluster.id}`}
                  position={{ lat: latitude, lng: longitude }}
                  text={pointCount}
                          selected={selected}
                          allSelected={allSelected}
                />
 
                </>
              );
            }else{
                if(properties.category == "pickup"){
                    return <PickupPin_Selection selected={properties.selected} order={properties} key={properties.id + "" + 1} id={properties.id + "" + 1} 
                       {...props} position={{ lat: properties.pickup.coordinates[1], lng: properties.pickup.coordinates[0] }} />
                }else {
                    return <DropOffPin_Selection selected={properties.selected} order={properties} key={properties.id + "" + 2} id={properties.id + "" + 2} 
                       {...props} position={{ lat: properties.delivery.coordinates[1], lng: properties.delivery.coordinates[0] }} />
                }
             // {order.delivery && }
         
             }
         })}
         <OrderPinPopUp_selection {...props} />


         {props.mapType == "google" ? <><DrawingManager
              ref={drawingRef}

             onLoad={() => {
                 dispatch({ type: "set_drawingRef", state: drawingRef })
             }}
             //  onPolygonComplete={onPolygonComplete}
             onOverlayComplete={(evt) => {
                 const { type, overlay } = evt;

                    const wasCtrlPressed = isCtrlOrMetaPressed.current;
                    console.log("Ctrl/Meta pressed?", wasCtrlPressed);

                 if (overlay) {
                     window.google.maps.event.clearInstanceListeners(overlay);
                     overlay.setMap(null);

                     // rectangle و "circle" و "polygon"
                         console.log("vszafgsdv ", overlay ,evt)

                     if (type == "polygon") {


                         const typedOverlay = overlay;
                         const coordinateFuncs = typedOverlay
                             .getPath()
                             .getArray();

                         const coordinates =
                             coordinateFuncsToCoordinates(coordinateFuncs);

                         if (coordinates.length < 3) {
                             return;
                         }

                        //  setPolygons((prevPolygons) => [
                        //      ...prevPolygons,
                        //      {
                        //          id: R.inc(polygons.length),
                        //          coordinates,
                        //          options: DefaultPolygonOptions,
                        //          prevCoordinates: [],
                        //          polygonInstance: null,
                        //      },
                        //  ]);

                         GM_resetDrawingToolsMode();

                         if(wasCtrlPressed){
                             GM_checkSelectedOrdersInShapes(coordinates)
                         }else {
                            dispatch(Table_ClearSelectedOrders())
                            GM_checkSelectedOrdersInShapes(coordinates)

                         }
                          drawingRef.current?.state.drawingManager?.setDrawingMode("polygon");

                         return;
                     }


                     if (type == "rectangle") {
                         const typedOverlay = overlay;
                         const bounds = typedOverlay.getBounds();

                         if (bounds) {
                             const sw = bounds.getSouthWest();
                             const ne = bounds.getNorthEast();

                             console.log("dwdfewfede ", {
                                 southWest: { lat: sw.lat(), lng: sw.lng() },
                                 northEast: { lat: ne.lat(), lng: ne.lng() },
                             })

                            //  setRectangle((prevRectangles) => [
                            //      ...prevRectangles,
                            //      {
                            //          bounds: {
                            //              southWest: { lat: sw.lat(), lng: sw.lng() },
                            //              northEast: { lat: ne.lat(), lng: ne.lng() },
                            //          },
                            //          rectangleInstance: null,
                            //          id: R.inc(rectangle.length),
                            //      },
                            //  ]);

                            
                         if(wasCtrlPressed){
                            GM_checkSelectedOrdersInRectangle({
                                 southWest: { lat: sw.lat(), lng: sw.lng() },
                                 northEast: { lat: ne.lat(), lng: ne.lng() },
                             })
                         }else {
                            dispatch(Table_ClearSelectedOrders())
                            GM_checkSelectedOrdersInRectangle({
                                    southWest: { lat: sw.lat(), lng: sw.lng() },
                                    northEast: { lat: ne.lat(), lng: ne.lng() },
                                })

                         }
                             

                         }

                         GM_resetDrawingToolsMode();
                        drawingRef.current?.state.drawingManager?.setDrawingMode("rectangle");
                     }


                     if (type === "circle") {
                         const typedOverlay = overlay;
                         const center = typedOverlay.getCenter();
                         const radius = typedOverlay.getRadius();

                         if (center) {
                             setCircle((prevCircles) => [
                                 ...prevCircles,
                                 {
                                     center,
                                     radius,
                                     circleInstance: null,
                                     id: R.inc(circle.length),
                                 },
                             ]);
                         }

                         GM_resetDrawingToolsMode();

                         return;
                     }


                 }

             

             }}

             options={{
                 drawingControl: true,
                 drawingControlOptions: {
                     drawingModes: [/*"circle", */ "polygon", "rectangle"]
                 },
                 polygonOptions: {
                     strokeWeight: 5,
                     fillOpacity: 0.3,

                     suppressUndo: true,
                 },
             }}
         />



         {polygons.map((polygon) => (
             <Polygon
                 key={polygon.id}
                 editable={false}
                 draggable={false}
                 paths={polygon.coordinates}


             />
         ))} 

             {rectangle.map((polygon) => (
                 <Rectangle
                     key={polygon.id}
                     editable={false}
                     draggable={false}
                     bounds={{
                         north: polygon.bounds.northEast.lat,
                         east: polygon.bounds.northEast.lng,
                         south: polygon.bounds.southWest.lat,
                         west: polygon.bounds.southWest.lng,
                     }}

                 />
             ))}

             {circle.map((polygon) => (
                 <Circle
                     key={polygon.id}
                     editable={false}
                     draggable={false}
                     center={polygon.center}
                     radius={polygon.radius}


                 />
             ))}

         </> : <>
         
             <FeatureGroup>
               <EditControl
                ref={ drawingRef}
                 onDrawStart={()=>{}}
                 position="bottomright"
                 onEdited={()=>{}}
                 onCreated={ onShapeDrawn}
                 onDeleted={()=>{}}
                 draw={{
                   rectangle: true,
                   circlemarker: false,
                   circle: false,
                   polygon: true ,
                   polyline : false ,
                   marker : false
                 }}
               />
             </FeatureGroup>
         </>}


         {/* <ButtonsContainer>
             <DrawingButtonsGroup selectedValue={buttonName}>
                 <DrawingButtonsGroup.Button
                     name={"polygon"}
                     onClick={() => {
                         if (drawingRef.current) {
                             drawingRef.current?.state.drawingManager?.setDrawingMode("polygon");
                         }
                     }}
                 />
        
                 <DrawingButtonsGroup.Button
                     name={"rectangle"}
                     onClick={() => {
                         if (drawingRef.current) {
                             drawingRef.current?.state.drawingManager?.setDrawingMode("rectangle");
                         }
                     }}
                 />
             </DrawingButtonsGroup>
         </ButtonsContainer> */}

</>




};




function pointIsInPolygon(point, polygon) {
    let isInside = false;
    const numPoints = polygon.length;

    for (let i = 0, j = numPoints - 1; i < numPoints; j = i++) {
        const xi = polygon[i].lng, yi = polygon[i].lat;
        const xj = polygon[j].lng, yj = polygon[j].lat;

        const intersect = ((yi > point.lat) !== (yj > point.lat)) &&
            (point.lng < (xj - xi) * (point.lat - yi) / (yj - yi) + xi);
        if (intersect) isInside = !isInside;
    }

    return isInside;
}
 
function pointIsInRectangle(point, rectangle) {
    const { northEast, southWest } = rectangle;

    return (
        point.lat >= southWest.lat &&
        point.lat <= northEast.lat &&
        point.lng >= southWest.lng &&
        point.lng <= northEast.lng
    );
}